import React, { useEffect, useState, useRef } from "react";
import { Navigate } from "react-router-dom";
// api gére les requetes vers l'api avec axios et la variable d'environnement;
import api from "../api";
import { useAuth } from "../provider/AuthProvider";
import UseTitle from "../components/useTitle";
import "./Signup.scss";

const Signup = () => {
  // Définition du titre de la page
  UseTitle("Enregistrement");

  // Gestion du token d'authentification
  const { setToken, setTokenRefresh } = useAuth();

  const formSignup = useRef(); // Gère les élements du formulaire
  // Gestion du message d'erreur du formulaire
  const [messageError, setMessageError] = useState("");

  // Redirection vers une autre page
  const [redirectTo, setRedirectTo] = useState();

  // Création des JWTokens
  const handleSignup = (e) => {
    e.preventDefault(); // Empeche le rafraichissement de la page

    // Récuperation des éléments du formulaire pour la requête
    const formData = {
      username: formSignup.current[0].value,
      email: formSignup.current[1].value,
      password: formSignup.current[2].value,
      passwordconfirm: formSignup.current[3].value,
    };

    // Vérification du formulaire
    if (!checkForm(formData)) {
      return;
    }

    api
      .post("/auth/users/", formData)
      .then((response) => {
        // Login du nouvel utilisateur et configuration des JWTokens
        api
          .post("/auth/jwt/create/", {
            username: formData.username,
            password: formData.password,
          })
          .then((response) => {
            // Configuration des JWTokens
            setToken(response.data.access);
            setTokenRefresh(response.data.refresh);
            // Redirection vers la page d'accueil
            setRedirectTo("/");
          })
          .catch(() => {});
      })
      .catch((error) => {
        // Recuperation du message d'erreur
        const message = error.response.data;
        // Création du message d'erreur en fonction de l'erreur
        if (message.username) {
          setMessageError("Nom d'utilisateur : " + message.username[0]);
        } else if (message.email) {
          setMessageError("E-mail : " + message.email[0]);
        } else if (message.password) {
          setMessageError("Mot de passe : " + message.password[0]);
        } else {
          setMessageError(
            "Erreur lors de la création du compte veuillez contacter l'administrateur"
          );
        }
      });
  };

  // Vérification du formulaire
  const checkForm = (formData) => {
    if (!formData.username) {
      setMessageError("Nom d'utilisateur manquant");
      return false;
    }
    if (!formData.email) {
      setMessageError("E-mail manquant");
      return false;
    }
    if (!formData.password) {
      setMessageError("Mot de passe manquant");
      return false;
    }
    if (!formData.passwordconfirm) {
      setMessageError("Confirmation du mot de passe manquant");
      return false;
    }
    if (formData.password !== formData.passwordconfirm) {
      setMessageError(
        "Le mot de passe et sa confirmation doivent être identiques"
      );
      return false;
    }
    return true;
  };

  useEffect(() => {
    formSignup.current[0].focus();
  }, [formSignup]);

  // Redirection vers une autre page choisie
  if (redirectTo) {
    return <Navigate to={redirectTo} replace={true} />;
  }

  return (
    <>
      <div className="signup">
        <h1>Enregistrement</h1>
        <form
          className="signup-form"
          ref={formSignup}
          onSubmit={(e) => handleSignup(e)}
        >
          <div className="inputs">
            <input
              type="text"
              id="username"
              name="username"
              autoComplete="username"
              placeholder="nom d'utilisateur"
              defaultValue=""
              required
            />
            <input
              type="email"
              id="email"
              name="email"
              autoComplete="email"
              placeholder="e-mail"
              defaultValue=""
              required
            />
            <input
              type="password"
              id="password"
              name="password"
              autoComplete="new-password"
              placeholder="mot de passe"
              defaultValue=""
              required
            />
            <input
              type="password"
              id="confirm_password"
              name="confirm_password"
              autoComplete="new-password"
              placeholder="confirmer mot de passe"
              defaultValue=""
              required
            />
          </div>
          <div className="submit">
            <button className="bt" type="submit">
              Enregistrement
            </button>
          </div>
        </form>
        {messageError && <span className="error">{messageError}</span>}
      </div>
    </>
  );
};

export default Signup;
